(() => {
  const modal = document.getElementById('IflWaterOffer');
  if (!modal) return;

  let variantId = Number(modal.dataset.variantId);
  const sizeInputs = modal.querySelectorAll('input[name="ifl-water-size"]');
  const image = modal.querySelector('.ifl-water-offer__image');
  const errorMessage = modal.querySelector('.ifl-water-offer__error');
  const productHandle = modal.dataset.productHandle;
  const checkoutUrl = modal.dataset.checkoutUrl || '/checkout';
  const dialog = modal.querySelector('.ifl-water-offer__dialog');
  const addButton = modal.querySelector('.ifl-water-offer__add');
  const dismissButtons = modal.querySelectorAll('.ifl-water-offer__continue, .ifl-water-offer__close, .ifl-water-offer__backdrop');
  sizeInputs.forEach((input) => input.addEventListener('change', () => {
    if (!input.checked || input.disabled) return;
    variantId = Number(input.value);
    modal.dataset.variantId = input.value;
    errorMessage.hidden = true;
    if (image && input.dataset.image) {
      image.removeAttribute('srcset');
      image.src = input.dataset.image;
      image.alt = input.dataset.title;
    }
  }));
  const sessionKey = 'ifl-water-offer-seen';
  let lastFocusedElement = null;
  let bypass = false;

  const remember = () => {
    try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {}
  };

  const wasSeen = () => {
    try { return sessionStorage.getItem(sessionKey) === '1'; } catch (_) { return false; }
  };

  const open = () => {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('ifl-water-offer-open');
    requestAnimationFrame(() => dialog.focus());
  };

  const close = () => {
    modal.hidden = true;
    document.body.classList.remove('ifl-water-offer-open');
    lastFocusedElement?.focus?.();
  };

  const continueToCheckout = () => {
    remember();
    bypass = true;
    window.location.assign(checkoutUrl);
  };

  const cartNeedsWater = async () => {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Unable to check cart');
    const cart = await response.json();
    return cart.item_count > 0 && !cart.items.some((item) => item.handle === productHandle || item.product_handle === productHandle);
  };

  document.addEventListener('submit', async (event) => {
    const submitter = event.submitter;
    if (bypass || !submitter?.matches('[name="checkout"]')) return;
    if (wasSeen()) return;

    event.preventDefault();
    try {
      if (await cartNeedsWater()) open();
      else continueToCheckout();
    } catch (_) {
      continueToCheckout();
    }
  }, true);

  addButton.addEventListener('click', async () => {
    if (!variantId || addButton.disabled) return;
    errorMessage.hidden = true;
    sizeInputs.forEach((input) => { input.dataset.wasDisabled = String(input.disabled); input.disabled = true; });
    addButton.disabled = true;
    addButton.querySelector('span:first-child').textContent = 'Adding…';
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('Unable to add product');
      continueToCheckout();
    } catch (_) {
      sizeInputs.forEach((input) => { input.disabled = input.dataset.wasDisabled === 'true'; });
      errorMessage.hidden = false;
      addButton.disabled = false;
      addButton.querySelector('span:first-child').textContent = 'Try adding again';
    }
  });

  dismissButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('ifl-water-offer__continue')) continueToCheckout();
      else { remember(); close(); }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;
    if (event.key === 'Escape') { remember(); close(); }
  });

  if (new URLSearchParams(window.location.search).get('ifl-water-offer') === 'preview') {
    open();
  }
})();
